import { CalculateVenueEnvMapper } from '@/data/http/impact-calculate-venue/env/mapper.ts';
import { CalculateVenueEssMapper } from '@/data/http/impact-calculate-venue/ess/mapper.ts';
import { CalculateVenue } from '@/domain/impact-calculate-venue/entities/calculate-venue.entity.ts';
import {
  CalculateVenueCo2,
  EMPTY_CALCULATE_VENUE_CO2,
} from '@/domain/impact-calculate-venue/entities/calculate-venue-co2.entity';
import { EMPTY_CALCULATE_VENUE_ENV } from '@/domain/impact-calculate-venue/entities/calculate-venue-env.entity.ts';
import { EMPTY_CALCULATE_VENUE_ESS } from '@/domain/impact-calculate-venue/entities/calculate-venue-ess.entity.ts';
import { computeCo2ScoreLetter } from '@/domain/impact-calculate-venue/utils/compute-co2-score-letter';
import { computeKgeCO2ByParticipant } from '@/domain/impact-calculate-venue/utils/compute-kg-co2-by-participant';

import { CalculateVenueCo2Mapper } from '../co2/mapper';
import { ResultsVenueDto } from './dto.type';

export class ResultsVenueMapper {
  static dtoToEntity(dto: ResultsVenueDto): CalculateVenue {
    // co2
    let calculateVenueCo2: CalculateVenueCo2;
    if (dto.co2) {
      calculateVenueCo2 = CalculateVenueCo2Mapper.dtoToEntity(dto.co2);
    } else {
      calculateVenueCo2 = EMPTY_CALCULATE_VENUE_CO2;
    }
    // kgeCO2ByParticipant
    const globalScoreTco2 = calculateVenueCo2.global.score;
    const totalCapacityOfAllDates = dto.totalAvgCapacity;
    const kgeCO2ByParticipant = computeKgeCO2ByParticipant(
      globalScoreTco2,
      totalCapacityOfAllDates,
    );
    // scoreLetter
    const scoreLetter = computeCo2ScoreLetter(kgeCO2ByParticipant);

    const calculateVenueEnv = dto.env
      ? CalculateVenueEnvMapper.dtoToEntity(dto.env)
      : EMPTY_CALCULATE_VENUE_ENV;
    const calculateVenueEss = dto.ess
      ? CalculateVenueEssMapper.dtoToEntity(dto.ess)
      : EMPTY_CALCULATE_VENUE_ESS;

    // update values
    calculateVenueCo2 = {
      ...calculateVenueCo2,
      global: {
        ...calculateVenueCo2.global,
        kgeCO2ByParticipant,
        scoreLetter,
      },
    };
    return {
      count: {
        dates: dto.countDates || 0,
        participants: dto.totalAvgCapacity || 0,
      },
      co2: calculateVenueCo2,
      env: calculateVenueEnv,
      ess: calculateVenueEss,
    };
  }
}
